export default __webpack_public_path__ + "static/media/wallet-connect.80b0a214.svg";